export default "__VITE_ASSET__CyndnonZ__"